module.exports = __webpack_public_path__ + "static/media/slide1-web.829f88fa.jpg";